import { TreeNodeDTO } from 'business/models/Models';
import { EExplorerNodesView, explorerNodesPaths } from 'components/explorer/constants';
import EViewType from 'enums/EViewType';
import React from 'react';
import { getTreeNodeImageProps } from 'utils/Global';
import NodeComponent from '../NodeComponent/NodeComponent';
import './NodesGroupView.scss';
interface NodesGroupViewProps {
  viewType: EViewType;
  selectedNodes: any[];
  childTreeNodes?: any;
  nodeClickHandler: (
    link: string,
    node: TreeNodeDTO,
    id: string,
    expanded: boolean,
    inputNodeName: string,
    eventDetail?: number,
  ) => void;
  loadImageIcon;
  selectedExplorerNode: TreeNodeDTO | null;
}
const nullUndefinedArray = [null, undefined];
const seedProteinArray = ['Seed', 'Protein'];
const validNodeTypes = [
  EExplorerNodesView.Screen,
  EExplorerNodesView.Experiment,
  EExplorerNodesView.Seed,
  EExplorerNodesView.ProteinFormulation,
  EExplorerNodesView.SynchrotronTripv4,
  EExplorerNodesView.SearchAnalysis,
  EExplorerNodesView.FragmentScreen,
  EExplorerNodesView.TextSearch,
];

export const getNodeLink = ({ type, id, extra }) => {
  if (!validNodeTypes.includes(type)) {
    return null;
  }

  const path = explorerNodesPaths[type] || EExplorerNodesView.Screen;

  if (type === 'ProteinFormulation') {
    return `/protein/${id}`;
  }

  if (nullUndefinedArray.includes(extra) || seedProteinArray.includes(type)) {
    return `/${type.toLowerCase()}/${id}`;
  }

  if (type === EExplorerNodesView.TextSearch) {
    return path;
  }

  return `/${path}/${extra.id}`;
};

export default function NodesGroupView(props: NodesGroupViewProps) {
  const {
    viewType,
    selectedNodes,
    childTreeNodes,
    nodeClickHandler,
    selectedExplorerNode,
  } = props;
  const renderChildNodes = () => {
    return childTreeNodes.map((nodeItem) => {
      const link = getNodeLink(nodeItem);
      return (
        <NodeComponent
          key={'tree-node-item' + nodeItem.id}
          viewType={viewType}
          imageProps={getTreeNodeImageProps(nodeItem)}
          name={nodeItem.name}
          datePrepared={nodeItem?.datePrepared}
          locked={nodeItem.locked}
          onClick={(e) => {
            nodeClickHandler(
              link,
              nodeItem,
              `node${nodeItem.id}`,
              true,
              `inputNameode${nodeItem.id}`,
              e.detail,
            );
          }}
          notSeen={nodeItem?.extra?.notSeen}
          selectedNodes={selectedNodes}
          node={nodeItem}
          selectedExplorerNode={selectedExplorerNode}
        />
      );
    });
  };
  return (
    <ul
      id={`nodesgroupview-maincontainer-${viewType}`}
      data-testid={`nodesgroupview-maincontainer-${viewType}`}
      className={`nodes-group-main-container-${viewType}`}
    >
      {renderChildNodes()}
    </ul>
  );
}
